import React from 'react';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeletePartnerModal = ({ open, onClose, onConfirm }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 600, fontSize: 20, mt: 2 }}>Confirmação de exclusão</DialogTitle>

      <DialogActions sx={{ px: 3, pb: 3, pt: 3, gap: 2 }}>
        <Button onClick={onClose} variant="outlined" color="primary" fullWidth sx={{ borderRadius: 24 }}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="outlined"
          color="error"
          fullWidth
          sx={{ borderRadius: 24, borderColor: 'error.main', color: 'error.main' }}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePartnerModal;
